import * as BasicFontWeight from './BasicFontWeight';

export const FONT_WEIGHT_LIGHT = BasicFontWeight.FONT_WEIGHT_300;

export const FONT_WEIGHT_REGULAR = BasicFontWeight.FONT_WEIGHT_400;

export const FONT_WEIGHT_MEDIUM = BasicFontWeight.FONT_WEIGHT_500;

export const FONT_WEIGHT_SEMIBOLD = BasicFontWeight.FONT_WEIGHT_600;

export const FONT_WEIGHT_BOLD = BasicFontWeight.FONT_WEIGHT_700;

const GenericFontWeight = {
    FONT_WEIGHT_LIGHT,
    FONT_WEIGHT_REGULAR,
    FONT_WEIGHT_MEDIUM,
    FONT_WEIGHT_SEMIBOLD,
    FONT_WEIGHT_BOLD,
};

export default GenericFontWeight;
